import { render, staticRenderFns } from "./NotificationDetailModal.vue?vue&type=template&id=9590472c&scoped=true"
import script from "./NotificationDetailModal.vue?vue&type=script&lang=ts"
export * from "./NotificationDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDetailModal.vue?vue&type=style&index=0&id=9590472c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9590472c",
  null
  
)

export default component.exports